export default function ZipAPI() {
  return (
    'TRw9CRpGgBGA0cbYLh9JTMHrRvg5KlQ9CZXLN8uhs2UNDHebhyGV6Mc9BtQ6hLY8'
  );
}



// WEBPACK FOOTER //
// ./src/zips.js